goog.provide('el8.ext.onboarding.noProfileDialog');

goog.require('el8.ext.ModalDialog');
goog.require('el8.template.ext.onboarding.noProfileDialog');


el8.ext.onboarding.noProfileDialog = (function() {

    var that = new el8.ext.ModalDialog({
        height: 317,
        width: 500,
        modal: true,
        draggable: false,
        contentFn: function() {
            return el8.template.ext.onboarding.noProfileDialog.content({
                supportEmail: el8Globals['SUPPORT_EMAIL'],
                supportPhone: el8Globals['SUPPORT_PHONE']
            });
        }
    });

    return that;

})();

